import { useAtom } from 'jotai'
import atomWithStorageWithErrorCatch from 'utils/atomWithStorageWithErrorCatch'

// Persisted in sessionStorage (not localStorage) so the active chain survives full page
// reloads / fresh URL loads within the same session — fixing cross-page network desync
// (e.g. swap -> liquidity) — while a brand-new app session still lets the URL ?chain= /
// wallet drive the initial chain instead of a stale remembered value.
export const SESSION_CHAIN_ID_KEY = 'macswap:sessionChainId'

const sessionChainIdAtom = atomWithStorageWithErrorCatch<number>(SESSION_CHAIN_ID_KEY, 0, () =>
  typeof window !== 'undefined' ? window.sessionStorage : (undefined as unknown as Storage),
)

export const useSessionChainId = () => {
  return useAtom(sessionChainIdAtom)
}
